/* @flow weak */
import Button from 'components/Button.jsx';
import Columns2 from 'components/Columns2.jsx';
import CurrentUser from 'auth/CurrentUser';
import Fieldset from 'components/Fieldset.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import FormSelect from 'components/FormSelect.jsx';
import GroupActions from 'groups/actions/GroupActions';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import React from 'react';
import SettingsContainer from './SettingsContainer.jsx';
import SettingsStore from 'stores/SettingsStore';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';

const UserPersonalInfoForm = React.createClass({
  mixins: [
    linkStateWithStores([
      CurrentUser,
      SettingsStore,
    ]),
  ],

  getInitialState() {
    return this.getStateFromStores();
  },

  getStateFromStores() {
    return {
      user: CurrentUser.isSignedIn() ? CurrentUser.getUser() : null,
      canSubmit: false,
      hasChanged: false,
      countries: SettingsStore.getSetting('countries'),
    };
  },

  disableButton() {
    this.setState({ canSubmit: false });
  },

  enableButton() {
    if (this.state.hasChanged) {
      this.setState({ canSubmit: true });
    }
  },

  enableChanged() {
    this.setState({ hasChanged: true });
  },

  submit(attrs, resetForm, invalidateForm) {
    // When the user changes country we reload all the user classes.
    // This is because the class subscription info changes depending on the user country.
    if (attrs['country_code'] !== CurrentUser.getUser().getCountryCode()) {
      GroupActions.loadGroups();
    }

    const emailChanged = (
      attrs.email && attrs.email !== CurrentUser.getUser().getEmail()
    );

    const reset = () => {
      this.disableButton();
      this.setState({ hasChanged: false });
    };

    const onSuccess = () => {
      ToastActions.showSuccessToast(
        emailChanged ?
          'Changes saved. Please verify your new email address.' :
          'Changes saved'
      );
    };

    const onFailure = (error) => {
      ToastActions.showAPIError(error);

      const errors = {};
      for (const field of error.field_errors) {
        errors[field['field_name']] = field.messages.join(', ');
      }

      invalidateForm(errors);
    };

    UserActions
      .update(attrs)
      .then(reset)
      .then(onSuccess, onFailure);
  },

  render() {
    let language = this.state.user.getLocale();

    // API accepts both en and en_US, but en-US is correct format
    if (language === 'en') {
      language = 'en-US';
    }

    return (
      <Form
        key={this.state.user.cid}
        onChange={this.enableChanged}
        onValid={this.enableButton}
        onValidSubmit={this.submit}
        onInvalid={this.disableButton}>
        <Fieldset legend="Personal information">
          <SettingsContainer>
            <Columns2 gutter="small">
              <div>
                <FormInput
                  label="First name"
                  name="first_name"
                  value={this.state.user.getFirstName()}
                  validations="minLength: 1"
                  validationError="First name is required"
                />
              </div>
              <div>
                <FormInput
                  label="Last name"
                  name="last_name"
                  value={this.state.user.getLastName()}
                  validations="minLength:1"
                  validationError="Last name is required"
                />
              </div>
            </Columns2>

            <Columns2 gutter="small">
              <div>
                <FormSelect
                  label="Country"
                  name="country_code"
                  options={this.state.countries.map(country => {
                    return { value: country.code, label: country.name };
                  })}
                  value={this.state.user.getCountryCode()}
                  validations="minLength: 1"
                  validationError="Country is required."
                />
              </div>
            </Columns2>

            {/* <Columns2 gutter="small">
              <div>
                <FormSelect
                  label="Language"
                  name="locale"
                  options={Languages}
                  value={language}
                  validations="minLength: 1"
                  validationError="Language is required." />
              </div>
            </Columns2> */}
          </SettingsContainer>

          <Button
            size="small"
            type="submit"
            disabled={!this.state.canSubmit}>
            Save
          </Button>
        </Fieldset>
      </Form>
    );
  },
});

export default UserPersonalInfoForm;



// WEBPACK FOOTER //
// ./src/settings/components/UserPersonalInfoForm.jsx